import { useMemo, useState } from 'react';
import { ImgSadGhost } from '@components/Images/ImgSadGhost';
import { ImgSkull } from '@components/Images/ImgSkull';
import { ImgAnglerFish } from '@components/Images/ImgAnglerFish';
import { ImgAppleMaggot } from '@components/Images/ImgAppleMaggot';

const ErrorIcons = [ImgSadGhost, ImgSkull, ImgAnglerFish, ImgAppleMaggot];

const ErrorPage = ({error}: {error: Error}) => {
  const ErrorIcon = useMemo(() => ErrorIcons[Math.floor(Math.random() * ErrorIcons.length)], []);
  const [showDetails, setShowDetails] = useState(false);
  const [copied, setCopied] = useState(false);
  const hasStack = !!error.stack;

  const copyDetails = () => {
    const text = hasStack ? `${error.message}\n\n${error.stack}` : error.message;
    void navigator.clipboard.writeText(text).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <div className="page-container">
      <div className="centered-content">
        <div className="ollama-logo crazy"><ErrorIcon size={70} /></div>
        <h1 className="error-title">UI Error</h1>
        <h2 className="error-subtitle">{error.message}</h2>
        <div className="error-description">
          Whoa! Something went completely bonkers on our end.
          Our llama is having a bit of a meltdown!
        </div>
        {hasStack && showDetails && (
          <pre className="error-stack">{error.stack}</pre>
        )}
        <div className="error-actions">
          {hasStack && (
            <button className="error-secondary-btn" onClick={() => setShowDetails((v) => !v)}>
              {showDetails ? 'Hide details' : 'More details'}
            </button>
          )}
          {hasStack && (
            <button className="error-secondary-btn" onClick={copyDetails}>
              {copied ? 'Copied!' : 'Copy details'}
            </button>
          )}
          <button className="home-btn" onClick={() => window.location.reload()}>
            Try Again
          </button>
        </div>
      </div>
    </div>
  );
};

export default ErrorPage;